import {UPDATE_ACTION_TIME, resetSession, setSessionExpired} from '../actions/page';
import {AUTH_USER, logout} from '../actions/auth';
import {actionTypes} from 'redux-resource';
import * as browser from '../../../util/cookie';

const COOKIE_NAME = 'LAST_ACTION_TIME';
const AUTH_NEEDS = [
	actionTypes.CREATE_RESOURCES_PENDING,
	actionTypes.DELETE_RESOURCES_PENDING,
	actionTypes.UPDATE_RESOURCES_PENDING
];

const MAX_ALLOWED_IDLE_TIME = 1000 * 60 * 15;

const checkAdminNecessity = ({type}) => type === UPDATE_ACTION_TIME || AUTH_NEEDS.includes(type);
const idleCheck = store => next => action => {
	const {
		page: {
			session: {
				lastActionTime,
				isExpired
			} = {}
		} = {}
	} = store.getState();

	if (action.type === AUTH_USER && action.user !== null) {
		next(resetSession());
		return next(action);
	} else if (action.type === UPDATE_ACTION_TIME && isExpired) {
		// prevent action time updating if session was expired during
		// routing between pages.
		return;
	} else if (checkAdminNecessity(action)) {
		const previousTime = lastActionTime || browser.getCookie(COOKIE_NAME);
		const time = Date.now();
		const idleTime = time - previousTime;

		if (idleTime > MAX_ALLOWED_IDLE_TIME) {
			browser.deleteCookie(COOKIE_NAME, {path: '/'});
			next(setSessionExpired());
			return next(logout());
		} else if (action.type !== UPDATE_ACTION_TIME) {
			next({type: UPDATE_ACTION_TIME});
		}

		browser.setCookie(COOKIE_NAME, time, {path: '/'});
	}

	return next(action);
};

export default idleCheck;



// WEBPACK FOOTER //
// ./src/client/redux/middlewares/idle-checker.js